export default class FormSubmitConfirmationModal {
  private readonly confirmSelector: string = '.js-confirmSubmit';
  private readonly closeSelector: string = '.js-closeModal';

  constructor(private readonly form: JQuery<HTMLFormElement>, private readonly modalTemplateSelector: string = '') {
    if (!this.modalTemplateSelector.length) {
      this.modalTemplateSelector = form.data('submit-confirmation-modal-selector') as string;
    }
    this.bindInterceptSubmit();
  }

  static initAll(): void {
    $('form[data-submit-confirmation-modal-selector]').map((i, element) => new FormSubmitConfirmationModal($(element) as JQuery<HTMLFormElement>));
  }

  private bindInterceptSubmit(): void {
    this.form.on('submit', (e) => {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      this.openConfirmationModal(e.target);
    });
  }

  protected bindClose(): void {
    $(this.closeSelector).on('click', () => $.colorbox.close());
  }

  protected bindSubmit(form: HTMLFormElement): void {
    $(this.confirmSelector).on('click', () => form.submit());
  }

  private openConfirmationModal(form: HTMLFormElement): void {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
    window.ACC.colorbox.open('', {
      html: $(this.modalTemplateSelector).html(),
      width: '500px',
      onComplete: (): void => {
        this.bindClose();
        this.bindSubmit(form);
        $.colorbox.resize();
      },
    });
  }
}
